<div class="mat-elevation-z8 mar-top-20">
  <mat-card>
    <mat-card-content>
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="custom-tabs"
        [selectedIndex]="activeTabIndex()" (selectedTabChange)="activeTabIndex.set($event.index)"
        [dynamicHeight]="true">
        <mat-tab label="Load Invoice">
          <ng-template matTabContent>
            <app-regularinvoice></app-regularinvoice>
          </ng-template>
        </mat-tab>
        <mat-tab label="Tote Invoice">
          <ng-template matTabContent>
            <app-toteinvoice></app-toteinvoice>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
